import { motion } from 'framer-motion';
import { RoadmapPhase as RoadmapPhaseType } from '../../types/roadmap';
import { H2, H3, H4, Body } from '../ui/Typography';

interface RoadmapPhaseProps {
  phase: RoadmapPhaseType;
  isCompleted: boolean;
  icon: React.ElementType;
}

export default function RoadmapPhase({ phase, isCompleted, icon: Icon }: RoadmapPhaseProps) {
  return (
    <div className="bg-white rounded-xl shadow-lg p-8">
      <div className="flex items-center mb-6">
        <Icon className={`w-8 h-8 mr-3 ${isCompleted ? 'text-secondary' : 'text-gray-400'}`} />
        <div>
          <H2 className="text-primary">{phase.period}</H2>
          <H3 className="text-gray-900">{phase.title}</H3>
        </div>
      </div>

      <div className="mb-6">
        <H4 className="text-gray-700">Objective:</H4>
        <Body className="text-gray-600">{phase.objective}</Body>
      </div>

      {phase.items && (
        <ul className="space-y-3 mb-6">
          {phase.items.map((item, index) => (
            <motion.li
              key={index}
              initial={{ opacity: 0, x: -20 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.3, delay: index * 0.1 }}
              className="flex items-center"
            >
              <span className="w-2 h-2 bg-secondary rounded-full mr-3"></span>
              <Body className="text-gray-600">{item}</Body>
            </motion.li>
          ))}
        </ul>
      )}

      {phase.sections && (
        <div className="space-y-8">
          {phase.sections.map((section, sectionIndex) => (
            <div key={sectionIndex} className="bg-gray-50 rounded-lg p-6">
              <H4 className="text-gray-900 mb-4">{section.subtitle}</H4>
              <ul className="space-y-3">
                {section.items.map((item, itemIndex) => (
                  <motion.li
                    key={itemIndex}
                    initial={{ opacity: 0, x: -20 }}
                    animate={{ opacity: 1, x: 0 }}
                    transition={{ duration: 0.3, delay: itemIndex * 0.1 }}
                    className="flex items-center"
                  >
                    <span className="w-2 h-2 bg-secondary rounded-full mr-3"></span>
                    <Body className="text-gray-600">{item}</Body>
                  </motion.li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}